import React, {useState} from 'react'
import Modal from 'components/Modal'
import { CloseIco } from '../../../modules/CustomIcons'
import './index.scss'
import { useTranslation } from 'react-i18next'

const WarningModal: React.FC<any> = (props : any) => {
  const {t} = useTranslation()
  // console.log("pro",props.textModal);
  
    return (
        <Modal
        width={560}
        height={229}
        visible={props.visibleModal}
        title={t("notification.attention")}
        className="warning-modal"
        onOk={props.onOk}
        onCancel={props.onCancel}
      >
        <div className="notification-content flex">
          <div className="error-notification__icon">
            <CloseIco />
          </div>
          <p>
           
            {props.textModal || t("salary.uploadingFileIsWrong")}
          </p>
        </div>
      </Modal>
    )
}
export default WarningModal